import { Skeleton } from '@mui/material'
import {
  addMonths,
  eachDayOfInterval,
  endOfMonth,
  startOfMonth
} from 'date-fns'
import { isNull } from 'lodash'
import React from 'react'

import STYLES from '../CalendarV2.module.sass'

import DaysOfTheWeekV2 from './DaysOfTheWeekV2'
import HeaderMonthV2 from './HeaderMonthV2'

type Props = {
  maxMonthsShown?: number
}

const CalendarSkeleton: React.FC<Props> = ({ maxMonthsShown = 4 }) => {
  const today = new Date()
  const months = Array.from({ length: maxMonthsShown }, (_, i) => {
    const monthStart = startOfMonth(addMonths(today, i))
    const monthEnd = endOfMonth(monthStart)
    const daysInMonth: Array<Date | null> = eachDayOfInterval({
      start: monthStart,
      end: monthEnd
    })
    const nullsToPrepend = (monthStart.getDay() + 6) % 7
    for (let i = 0; i < nullsToPrepend; i++) {
      daysInMonth.unshift(null)
    }
    return {
      month: monthStart,
      days: daysInMonth
    }
  })

  return (
    <div className={STYLES.calendar}>
      <DaysOfTheWeekV2 />
      {months.map(({ month, days }) => (
        <div key={month.toString()}>
          <HeaderMonthV2 currentMonthInView={month} />
          <div className={STYLES.days}>
            {days.map((day, i) => (
              <div key={day?.toString() || i} className={STYLES.skeletonDay}>
                {!isNull(day) && (
                  <Skeleton
                    variant="rectangular"
                    width={40}
                    height={40}
                    sx={{
                      borderRadius: '100px',
                      backgroundColor: 'rgba(0, 0, 0, 0.08)'
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default CalendarSkeleton
